<div class="horizinns-container center contact-us-container" style="padding-top: 100px; padding-bottom:100px;">
  <mat-card class="horizinns-card mw-60 even-more-blur white-blur">
    <mat-card-header>
      <div>
        <img src="assets/images/logo_full_900.png" alt="Horizinns Logo" />
        <div style="display: flex; flex-direction: row; align-items: center; justify-content: center;">
          <i class="fa-solid fa-envelope" style="height: 40px; width: 40px; font-size: 40px; margin-right: 8px; color: #0d8e8c;"></i>
          <h2 class="heading-title">Contact Us</h2>
        </div>
      </div>
    </mat-card-header>

    <mat-card-content>
      @if(!submitted) {
        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
  
          <div class="form-row">
            <mat-form-field appearance="outline">
              <mat-label>First Name</mat-label>
              <input matInput formControlName="firstName" required />
              <mat-error *ngIf="f.firstName.hasError('required')">Required</mat-error>
            </mat-form-field>
  
            <mat-form-field appearance="outline">
              <mat-label>Last Name</mat-label>
              <input matInput formControlName="lastName" required />
              <mat-error *ngIf="f.lastName.hasError('required')">Required</mat-error>
            </mat-form-field>
          </div>
  
          <!-- Contact Method Toggle -->
          <div class="contact-method-toggle">
            <mat-label>Contact Preference</mat-label>
            <mat-button-toggle-group formControlName="contactMethod" aria-label="Contact method">
              <mat-button-toggle value="email">Email</mat-button-toggle>
              <mat-button-toggle value="phone">Phone</mat-button-toggle>
            </mat-button-toggle-group>
            <mat-error *ngIf="f.contactMethod.hasError('required') && f.contactMethod.touched">
              Please choose how you'd like to be contacted
            </mat-error>
          </div>
  
          <!-- Email field - shown only when email selected -->
          <mat-form-field appearance="outline" class="full-width" *ngIf="f.contactMethod.value === 'email'">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" type="email" placeholder="example@domain.com" />
            <mat-error *ngIf="f.email.hasError('required')">Email is required</mat-error>
            <mat-error *ngIf="f.email.hasError('email')">Invalid email format</mat-error>
          </mat-form-field>
  
          <!-- Phone field - shown only when phone selected -->
          <mat-form-field appearance="outline" class="full-width" *ngIf="f.contactMethod.value === 'phone'">
            <mat-label>Phone Number</mat-label>
            <input matInput formControlName="phone" type="tel" placeholder="(555) 123-4567" />
            <mat-error *ngIf="f.phone.hasError('required')">Phone is required</mat-error>
            <mat-error *ngIf="f.phone.hasError('pattern')">Invalid phone format</mat-error>
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Topic</mat-label>
            <mat-select formControlName="contactTopic" required>
              <mat-option [value]="null">Select Topic</mat-option>
              <mat-option *ngFor="let topic of contactTopics" [value]="topic">
                {{ topic | titlecase }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="f.contactTopic.hasError('required')">Required</mat-error>
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Message</mat-label>
            <textarea
              matInput
              formControlName="message"
              rows="5"
              maxlength="1000"
              placeholder="How can we help you?"
              required>
            </textarea>
            <mat-hint align="end">{{ f.message.value?.length || 0 }}/1000</mat-hint>
            <mat-error *ngIf="f.message.hasError('required')">Message is required</mat-error>
          </mat-form-field>
  
          <div class="actions">
            <button
              mat-flat-button
              class="metallic-text-btn-blue"
              type="submit"
              [disabled]="contactForm.invalid || loading">
              {{ loading ? 'Sending...' : 'Submit' }}
              <mat-icon>send</mat-icon>
            </button>
          </div>
        </form>
      } @else {
        <app-success-error [success]="submitted"></app-success-error>
        <div>
          <h2>Submission Successful</h2>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>